import { render } from "./Vault.vue?vue&type=template&id=18c6ad6a&scoped=true&ts=true"
import script from "./Vault.vue?vue&type=script&setup=true&lang=ts"
export * from "./Vault.vue?vue&type=script&setup=true&lang=ts"

import "./Vault.vue?vue&type=style&index=0&id=18c6ad6a&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c6ad6a"],['__file',"src/views/vault/Vault.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18c6ad6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18c6ad6a', __exports__)) {
    console.log('reload')
    api.reload('18c6ad6a', __exports__)
  }
  
  module.hot.accept("./Vault.vue?vue&type=template&id=18c6ad6a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('18c6ad6a', render)
  })

}


export default __exports__